import caro_pic_one from 'assets/csdd_images/caro_pic_one.png';
import caro_y from 'assets/csdd_images/caro_y_final.png';
import caro_x from 'assets/csdd_images/car_x_final.png';
import caro_special from 'assets/csdd_images/caro_another.png';
import MKTypography from 'components/MKTypography';
import MKBox from 'components/MKBox';

const CarouselHome = () => {
  var items = [
    {
      name: 'Welcome to the Chamber of Suppliers Development and Diversity',
      image: caro_pic_one,
      alt: 'Caro Pic 1',
      active: true,
    },
    {
      name: 'Empowering Members through Development',
      image: caro_y,
      alt: 'Caro Pic 2',
      active: false,
    },
    {
      name: 'Championing the Needs and Rights of Suppliers',
      image: caro_special,
      alt: 'Caro Pic 3',
      active: false,
    },
    {
      name: 'Fairness, Transparency and Excellence in Procurement Processes',
      image: caro_x,
      alt: 'Caro Pic 4',
      active: false,
    },
  ];
  return (
    <div
      id='carouselExampleCaptions'
      className='carousel slide'
      data-bs-ride='carousel'
    >
      <div className='carousel-indicators'>
        {items.map((item, index) => {
          return (
            <button
              key={item.name}
              type='button'
              className={item.active ? 'active' : ''}
              data-bs-target='#carouselExampleCaptions'
              data-bs-slide-to={`${index}`}
              aria-current={item.active ? 'true' : ''}
              aria-label={`Slide ${index + 1}`}
            ></button>
          );
        })}
      </div>
      <div className='carousel-inner'>
        {items.map((item) => {
          return (
            <div
              className={item.active ? 'carousel-item active' : 'carousel-item'}
              key={item.name}
            >
              <MKBox
                key={item.name}
                minHeight='75vh'
                width='100%'
                sx={{
                  backgroundImage: `url(${item.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'top',
                  display: 'grid',
                  placeItems: 'center',
                }}
              >
                <MKTypography
                  textAlign='center'
                  variant='h1'
                  color='white'
                  mt={-6}
                  mb={1}
                  sx={({ breakpoints, typography: { size } }) => ({
                    [breakpoints.down('md')]: {
                      fontSize: size['3xl'],
                    },
                  })}
                >
                  {item.name}
                </MKTypography>
              </MKBox>
            </div>
          );
        })}
      </div>
      <button
        className='carousel-control-prev'
        type='button'
        data-bs-target='#carouselExampleCaptions'
        data-bs-slide='prev'
      >
        <span className='carousel-control-prev-icon' aria-hidden='true'></span>
        <span className='visually-hidden'>Previous</span>
      </button>
      <button
        className='carousel-control-next'
        type='button'
        data-bs-target='#carouselExampleCaptions'
        data-bs-slide='next'
      >
        <span className='carousel-control-next-icon' aria-hidden='true'></span>
        <span className='visually-hidden'>Next</span>
      </button>
    </div>
  );
};
export default CarouselHome;
